module.exports = __webpack_public_path__ + "static/img_2677_optimized-a6eb0b583b20c02056bfe92aae77c2bc.jpg";